import { GameEvent } from '@/types'

import { AdvAction } from '../adv'

export enum MessageAction {
    pong = 'pong',
    userInfo = 'userInfo',
    getUser = 'getUser',
    getPlatformInfo = 'getPlatformInfo',
    platformInfo = 'platformInfo',
    getState = 'getState',
    getCloudSaveState = 'getCloudSaveState',
    setCloudSaveState = 'setCloudSaveState',
    cloudSaveStateResponse = 'cloudSaveStateResponse',
    cloudSaveOperationResponse = 'cloudSaveOperationResponse',
    setItems = 'setItems',
    deleteItems = 'deleteItems',
    initStorage = 'initStorage',
    authorizeUser = 'authorizeUser',
    requestPurchase = 'requestPurchase',
    requestTopup = 'requestTopup',
    purchaseStatus = 'purchaseStatus',
    topupStatus = 'topupStatus',
    unknownMessageAction = 'unknownMessageAction',
    unknownMessageType = 'unknownMessageType',
    loginError = 'loginError',
}

export type OutcomingMessage = {
    action: MessageAction | AdvAction
    payload?: unknown
    type?: 'adv' | 'liveness' | 'error' | 'storage' | 'in-game-payments' | 'cloud-save'
    originalMessageEvent: GameEvent
}
